export default () => (
  <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-15c.52 0 .94.42.94.94v4.37a.94.94 0 1 1-1.88 0V7.94c0-.52.42-.94.94-.94Zm-1.25 8.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z" />
);
